"use strict";
import Utils from "../../util/drawing_utils";
import { GRID_SIZE } from "./constants";
const { diff } = Utils;
export function snapToGrid(v) {
  return v.snap(GRID_SIZE);
}
const roundUpToNearestMultipleOf = (mult) => (n) => {
  return mult * Math.ceil(n / mult);
};
const roundUpToGrid = roundUpToNearestMultipleOf(GRID_SIZE);
function maxLengthF(vector, l) {
  return vector.length() > l ? vector.normalize(l) : vector;
}
export function getDragFunctionFor(minLength = 0, maxLength = Infinity) {
  if (minLength > maxLength) {
    throw Error(`Max length (${maxLength}) shouldn't be smaller than min length (${minLength})`);
  }
  const min = roundUpToGrid(minLength);
  const max = minLength > maxLength ? minLength : maxLength;
  return (dragPoint, { fixed }) => {
    const fixedPoint = snapToGrid(fixed);
    const dragOffset = maxLengthF(diff(dragPoint, fixedPoint).minLength(min), max);
    return snapToGrid(fixedPoint.add(dragOffset));
  };
}
export function getConnectorFromFirstDragPoint(dragPoints) {
  return [dragPoints[0]];
}
export function get2ConnectorsFromDragPoints(dragPoints) {
  return dragPoints;
}
export function getDisplayName(component) {
  return component.displayName || component.name || "Component";
}
